<template>
  <el-row class="m-0 width-100-p mt-20">
    <el-col
      class="d-flex align-item-center px-10 py-0"
      :span="
        $vuetify.display.width >= 1500
          ? 6
          : $vuetify.display.width >= 500
          ? 12
          : 24
      "
    >
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4 card-a1"
      >
        <el-col :span="24" class="px-3">
          <h6 class="text-white">{{ dashboardData.fuel_avoided.title }}</h6>
        </el-col>
        <el-col :span="24" class="x-y-center">
          <div v-if="$vuetify.display.width >= 1500" class="width-80 height-80 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#avoided-fossil-fuel-icon"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#avoided-fossil-fuel-icon-60"></use>
            </svg>
          </div>
          <p :class="[
                'text-white mb-0 flex-grow-1',
                $vuetify.display.width >= 1500 ? 'font-30-b' : 'font-20-b'
              ]">
              {{ dashboardData.fuel_avoided.value.toLocaleString() }}
          </p>
        </el-col>
      </div>
    </el-col>
    <el-col
      :class="$vuetify.display.width < 500 ? 'd-flex align-item-center p-2 py-0 mt-20' : 'd-flex align-item-center px-10 py-0'"
      :span="
        $vuetify.display.width >= 1500
          ? 6
          : $vuetify.display.width >= 500
          ? 12
          : 24
      "
    >
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4 card-a1"
      >
        <el-col :span="24" class="px-3">
          <h6 class="text-white">{{ dashboardData.kilometer_driven.title }}</h6>
        </el-col>
        <el-col :span="24" class="x-y-center">
          <div v-if="$vuetify.display.width >= 1500" class="width-80 height-80 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#ev-distance"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#ev-distance-60"></use>
            </svg>
          </div>
            <p :class="[
                'text-white mb-0 flex-grow-1',
                $vuetify.display.width >= 1500 ? 'font-30-b' : 'font-20-b'
              ]">
              {{ dashboardData.kilometer_driven.value.toLocaleString() }}
            </p>
        </el-col>
      </div>
    </el-col>
    <el-col
      :class="$vuetify.display.width < 1500 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0'"
      :span="
        $vuetify.display.width >= 1500
          ? 6
          : $vuetify.display.width >= 500
          ? 12
          : 24
      "
    >
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4 card-a1"
      >
        <el-col :span="24" class="px-3">
          <h6 class="text-white">
            {{ dashboardData.charger_count.title }}
          </h6>
        </el-col>
        <el-col :span="24" class="x-y-center">
          <div v-if="$vuetify.display.width >= 1500" class="width-80 height-80 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-charging-site"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-charging-site-60"></use>
            </svg>
          </div>
             <p :class="[
                'text-white mb-0 flex-grow-1',
                $vuetify.display.width >= 1500 ? 'font-30-b' : 'font-20-b'
              ]">
              {{ dashboardData.charger_count.value.toLocaleString() }}
            </p>
        </el-col>
      </div>
    </el-col>
    <el-col
    
      :class="$vuetify.display.width < 1500 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0'"
      :span="
        $vuetify.display.width >= 1500
          ? 6
          : $vuetify.display.width >= 500
          ? 12
          : 24
      "
    >
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4 card-a1"
      >
        <el-col :span="24" class="px-3">
          <h6 class="text-white">
            {{ dashboardData.number_of_session.title }}
          </h6>
        </el-col>
        <el-col :span="24" class="x-y-center">
          <div v-if="$vuetify.display.width >= 1500" class="width-80 height-80 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-charging-sessions"></use>
            </svg>
          </div>
          <div v-if="$vuetify.display.width < 1500" class="width-60 height-60 ml-20 mr-20">
            <svg>
              <use href="@/assets/svg/icon-sprite.svg#num-sessions-60"></use>
            </svg>
          </div>
            <p :class="[
                'text-white mb-0 flex-grow-1',
                $vuetify.display.width >= 1500 ? 'font-30-b' : 'font-20-b'
              ]">
              {{ dashboardData.number_of_session.value.toLocaleString() }}
            </p>
        </el-col>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    dataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      dashboardData: {
        fuel_avoided: { title: "", value: "0" },
        kilometer_driven: { title: "", value: "0" },
        charger_count: { title: "", value: "0" },
        number_of_session: { title: "", value: "0" },
      },
    };
  },
  watch: {
    dataProp: {
      handler: function (newValue) {
        this.dashboardData.fuel_avoided = newValue.fuel_avoided;
        this.dashboardData.kilometer_driven = newValue.distance_traveled;
        this.dashboardData.charger_count = newValue.charger_count; //missing
        this.dashboardData.number_of_session = newValue.session_count;
      },
      deep: true,
    },
  },
  methods: {},
};
</script>
